(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("aplayer"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "aplayer"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("prop-types"), require("aplayer")) : factory(root["react"], root["prop-types"], root["aplayer"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition